import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.99 12.22c-.6 0-.999.391-.999.978v7.82c0 .587.4.978.999.978.6 0 .999-.391.999-.978v-7.82c0-.587-.4-.978-.999-.978m-7.99 0c-.599 0-.999.391-.999.978v7.82c0 .587.4.978 1 .978.598 0 .998-.391.998-.978v-7.82c0-.587-.4-.978-.999-.978m3.995 1.955c-.6 0-.999.391-.999.978v7.82c0 .587.4.978 1 .978.598 0 .998-.39.998-.977v-7.821c0-.587-.4-.978-.999-.978M23.48 9.874c-.998-2.15-3.096-3.52-5.492-3.52h-.5C15.99 2.055 11.296-.39 6.802.783 1.908 1.956-.988 6.746.31 11.536a8.93 8.93 0 0 0 3.096 4.692c.4.293 1.099.293 1.398-.195.3-.391.3-1.076-.2-1.369-1.198-.88-1.997-2.248-2.396-3.617-1-3.617 1.298-7.43 4.993-8.31 3.696-.977 7.59 1.271 8.49 4.889.1.39.499.782.998.782h1.299c1.598 0 2.996.88 3.695 2.346.4.977.5 2.053.1 3.03-.4.978-1.099 1.76-2.098 2.151-.499.196-.699.782-.499 1.27q.3.587.899.587c.1 0 .3 0 .4-.097 1.497-.587 2.596-1.76 3.195-3.226.5-1.564.4-3.129-.2-4.595"
    }, null, -1)
  ]))]))
}
export default { render: render }